export const sampleResultData = {
  school: {
    name: "Excellent Model Secondary School",
    address: "123 Education Avenue, Ikeja, Lagos State, Nigeria",
    phone: "+234-80-1234-5678",
    email: "info@excellentmodel.edu.ng",
    motto: "Excellence in Character and Learning",
    logoUrl: "",
    ministry: "Ministry of Education, Lagos State"
  },
  student: {
    fullName: "Adebayo, Chukwuma Samuel",
    admissionNumber: "ADM/2021/0456",
    className: "SSS 3A",
    gender: "Male",
    dateOfBirth: "15/03/2006",
    numberOfStudentsInClass: 32,
    term: "Second Term",
    session: "2023/2024",
    passportPhotoUrl: ""
  },
  subjects: [
    {
      subject: "English Language",
      assessment1: 14,
      assessment2: 13,
      caTest: 9,
      examScore: 55,
      total: 91,
      grade: "A1",
      positionInClass: 3,
      highestInClass: 94,
      remark: "Excellent"
    },
    {
      subject: "Mathematics",
      assessment1: 12,
      assessment2: 11,
      caTest: 8,
      examScore: 48,
      total: 79,
      grade: "B2",
      positionInClass: 8,
      highestInClass: 85,
      remark: "Very Good"
    },
    {
      subject: "Physics",
      assessment1: 13,
      assessment2: 12,
      caTest: 7,
      examScore: 52,
      total: 84,
      grade: "A1",
      positionInClass: 2,
      highestInClass: 88,
      remark: "Excellent"
    },
    {
      subject: "Chemistry",
      assessment1: 11,
      assessment2: 10,
      caTest: 6,
      examScore: 45,
      total: 72,
      grade: "B2",
      positionInClass: 12,
      highestInClass: 78,
      remark: "Very Good"
    },
    {
      subject: "Biology",
      assessment1: 14,
      assessment2: 13,
      caTest: 9,
      examScore: 58,
      total: 94,
      grade: "A1",
      positionInClass: 1,
      highestInClass: 94,
      remark: "Excellent"
    },
    {
      subject: "Geography",
      assessment1: 10,
      assessment2: 9,
      caTest: 5,
      examScore: 38,
      total: 62,
      grade: "C4",
      positionInClass: 18,
      highestInClass: 70,
      remark: "Credit"
    },
    {
      subject: "Economics",
      assessment1: 12,
      assessment2: 11,
      caTest: 7,
      examScore: 42,
      total: 72,
      grade: "B2",
      positionInClass: 10,
      highestInClass: 76,
      remark: "Very Good"
    },
    {
      subject: "Agricultural Science",
      assessment1: 13,
      assessment2: 12,
      caTest: 8,
      examScore: 46,
      total: 79,
      grade: "B2",
      positionInClass: 7,
      highestInClass: 82,
      remark: "Very Good"
    },
    {
      subject: "Christian Religious Knowledge",
      assessment1: 14,
      assessment2: 13,
      caTest: 9,
      examScore: 54,
      total: 90,
      grade: "A1",
      positionInClass: 2,
      highestInClass: 92,
      remark: "Excellent"
    },
    {
      subject: "Civic Education",
      assessment1: 11,
      assessment2: 10,
      caTest: 6,
      examScore: 40,
      total: 67,
      grade: "B3",
      positionInClass: 15,
      highestInClass: 72,
      remark: "Good"
    }
  ],
  affectiveDomain: [
    { label: "Punctuality", score: 4, maxScore: 5 },
    { label: "Attendance", score: 5, maxScore: 5 },
    { label: "Neatness", score: 4, maxScore: 5 },
    { label: "Honesty", score: 5, maxScore: 5 },
    { label: "Obedience", score: 4, maxScore: 5 },
    { label: "Leadership", score: 3, maxScore: 5 },
    { label: "Cooperation", score: 4, maxScore: 5 },
    { label: "Respect for Authority", score: 5, maxScore: 5 }
  ],
  psychomotorDomain: [
    { label: "Sports", score: 4, maxScore: 5 },
    { label: "Handwriting", score: 3, maxScore: 5 },
    { label: "Drawing", score: 3, maxScore: 5 },
    { label: "Craft Work", score: 4, maxScore: 5 },
    { label: "Public Speaking", score: 4, maxScore: 5 },
    { label: "Debate", score: 5, maxScore: 5 }
  ],
  remarks: {
    formTeacherName: "Mrs. Funke Adebayo",
    formTeacherRemark: "Samuel is a diligent and focused student who has shown remarkable improvement this term. He participates actively in class discussions and maintains good relationships with his peers. Keep up the excellent work!",
    principalName: "Mr. James Okonkwo",
    principalRemark: "An outstanding performance this term. Samuel's academic excellence and good conduct make him a role model for other students. We are proud of his achievements and expect greater things from him.",
    nextTermBegins: "September 18, 2024"
  },
  daysPresent: 85,
  daysSchoolOpened: 90
};
